var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilUsed = function SvgPencilUsed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pencil-used_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 19,
    width: 9,
    height: 3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.976h-.05v1.752h7.417v-1.752H2Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pencil-used_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pencil-used_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 19.027,
    width: 9,
    height: 3,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 19.027h9v3H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.581 21.642H2.736c-.408 0-.736-.346-.736-.765 0-.419.328-.763.736-.763H8.58c.406 0 .736.343.736.763 0 .421-.33.767-.736.767"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.581 21.642H2.736c-.408 0-.736-.346-.736-.765 0-.419.328-.763.736-.763H8.58c.406 0 .736.343.736.763 0 .421-.33.767-.736.767",
    fill: "#58B847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.581 21.542H2.736v.2H8.58v-.2Zm-5.845 0c-.348 0-.636-.297-.636-.665h-.2c0 .47.37.865.836.865v-.2Zm-.636-.665a.65.65 0 0 1 .636-.663v-.2c-.467 0-.836.393-.836.863h.2Zm.636-.663H8.58v-.2H2.736v.2Zm5.845 0a.65.65 0 0 1 .636.663h.2c0-.472-.372-.863-.836-.863v.2Zm.636.663c0 .37-.29.667-.636.667v.2c.465 0 .836-.395.836-.867h-.2Z",
    fill: "#fff",
    mask: "url(#pencil-used_svg__b)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "pencil-used_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 2,
    width: 15,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.914 2h13.365v20H9.914V2Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pencil-used_svg__c)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pencil-used_svg__d",
    maskUnits: "userSpaceOnUse",
    x: 8.914,
    y: 1,
    width: 15,
    height: 22,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.914 1h15v22h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.713 21.871a.935.935 0 0 0 .477.128v-.002a.95.95 0 0 0 .472-.124l4.43-2.516c.163-.094.298-.23.388-.4l6.584-12.325c.462-.869.158-1.967-.68-2.451l-3.4-1.952a1.66 1.66 0 0 0-1.322-.157 1.73 1.73 0 0 0-1.04.859l-6.585 12.322c-.089.17-.133.361-.122.554l.293 5.23c.018.35.21.664.505.834Zm1.37-2.566-.184-3.32 6.33-11.852 3 1.72-6.334 11.856-2.812 1.596Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.713 21.871a.935.935 0 0 0 .477.128v-.002a.95.95 0 0 0 .472-.124l4.43-2.516c.163-.094.298-.23.388-.4l6.584-12.325c.462-.869.158-1.967-.68-2.451l-3.4-1.952a1.66 1.66 0 0 0-1.322-.157 1.73 1.73 0 0 0-1.04.859l-6.585 12.322c-.089.17-.133.361-.122.554l.293 5.23c.018.35.21.664.505.834Zm1.37-2.566-.184-3.32 6.33-11.852 3 1.72-6.334 11.856-2.812 1.596Z",
    fill: "#58B847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.19 21.999v.2h.2v-.2h-.2Zm-.477-.128.102-.172-.002-.001-.1.173Zm.477.126v-.2h-.2v.2h.2Zm.472-.124-.098-.174.098.174Zm4.43-2.516.1.174-.1-.174Zm.388-.4-.177-.095.177.095Zm6.584-12.325.177.094-.177-.094Zm-.68-2.451.1-.173-.1.173Zm-3.4-1.952.1-.174-.1.174Zm-1.322-.157.057.192h.002l-.059-.192Zm-1.04.859.175.094-.176-.094Zm-6.585 12.322-.177-.094v.002l.177.092Zm-.122.554.2-.011v-.001l-.2.012Zm.293 5.23.2-.01v-.002l-.2.011Zm1.69-5.052-.176-.094-.026.05.003.055.2-.01Zm.185 3.32-.2.011.018.323.28-.16-.098-.174Zm6.146-15.172.1-.174-.18-.102-.097.182.177.094Zm3 1.72.176.095.091-.172-.168-.096-.1.173ZM14.895 17.71l.1.174.05-.028.027-.052-.177-.094ZM11.19 21.8a.736.736 0 0 1-.375-.1l-.203.345c.18.106.38.155.578.155v-.4Zm-.2.198V22h.4v-.002h-.4Zm.573-.298a.75.75 0 0 1-.373.098v.4c.197 0 .394-.05.572-.15l-.199-.348Zm4.43-2.516-4.43 2.516.198.348 4.43-2.516-.197-.348Zm.31-.32a.802.802 0 0 1-.31.32l.2.347c.194-.112.355-.275.464-.48l-.354-.187Zm6.585-12.325-6.585 12.324.353.189 6.585-12.325-.353-.188Zm-.604-2.184c.742.428 1.016 1.408.604 2.184l.353.188c.51-.96.177-2.179-.756-2.718l-.2.346Zm-3.4-1.952 3.4 1.952.2-.347-3.4-1.952-.2.347Zm-1.163-.139a1.46 1.46 0 0 1 1.163.14l.2-.348a1.86 1.86 0 0 0-1.48-.174l.117.382Zm-.923.761a1.53 1.53 0 0 1 .921-.76l-.114-.384c-.5.149-.913.49-1.16.957l.353.187Zm-6.585 12.323 6.585-12.322-.353-.189L9.86 15.16l.353.188Zm-.098.448a.862.862 0 0 1 .1-.45l-.356-.184c-.104.2-.157.427-.143.658l.399-.024Zm.292 5.23-.292-5.23-.4.023.293 5.23.4-.023Zm.406.673a.821.821 0 0 1-.406-.672l-.4.02c.022.418.251.794.607.998l.2-.346Zm.886-5.702.184 3.32.4-.022-.184-3.32-.4.022ZM18.052 4.04l-6.33 11.852.353.188 6.33-11.852-.353-.188Zm3.276 1.64-3-1.72-.199.347 3 1.72.199-.346Zm-6.256 12.124 6.333-11.855-.353-.189-6.333 11.856.353.188Zm-2.89 1.676 2.812-1.596-.197-.348-2.813 1.596.197.348Z",
    fill: "#fff",
    mask: "url(#pencil-used_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.445 10.448c-.16 0-.32-.041-.47-.126l-4.739-2.68a1.043 1.043 0 0 1-.392-1.386.964.964 0 0 1 1.335-.408l4.739 2.68c.477.27.656.89.394 1.387a.98.98 0 0 1-.867.533Z",
    fill: "#58B847"
  }))));
};
export default SvgPencilUsed;